<template>
  <div class="combobox-sale-item-info">
    <div class="float-right w-fit pl-1 text-right">
      <span class="line-through" v-if="hasCustomUnitPrice && agreedUnitPrice">
        {{ normalizeCurrency(Number(agreedUnitPrice)) }}
      </span>
      <span :class="{ 'text-warning': !unitPrice }">{{ unitPriceText }}</span>
    </div>
    <div class="space-x-1">
      <FontAwesomeIcon :icon="['fas', 'money-bill-wave']" class="text-green-800" title="Verkoop" />
      <span class="inline-block font-bold!">Verkoop:</span>
      <span>{{ item.name }} {{ item.getUnitName() }} </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import type { SaleItem } from "@/models/sale-item.model"
import { normalizeCurrency } from "@/helper/number-helper"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import usePriceAgreements from "@/composables/administration/price-agreements"
import type { Project } from "@/models/project.model"

const props = defineProps<{
  item: SaleItem
  unitPrice: string | undefined
  project?: Project
  hasCustomUnitPrice?: boolean
}>()

defineOptions({
  inheritAttrs: false
})

const { unitPrice: agreedUnitPrice } = usePriceAgreements(
  computed(() => props.project),
  props.item
)

const unitPriceText = computed(() => {
  return props.unitPrice ? normalizeCurrency(Number(props.unitPrice)) : "???"
})
</script>

<style scoped></style>
